export default __webpack_public_path__ + "static/media/kunalShah.1e21019f.png";